// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"bc801e59","182":"14f20031","939":"93b9f9a2"}[chunkId] + ".chunk.js";
};